export default __webpack_public_path__ + "static/media/twentyeightdays4.85860ed7.jpg";